/* eslint-disable quote-props */
import { Controller } from '@hotwired/stimulus';
import { extend, noop } from 'lodash';

/*
  Se trata de marcar un link cualquiera con data-controller="overlay-link" y este componente se
  encarga de mostrar el overlay cuando hagan click en el enlace.
  Los eventos de delete:start y delete:done son para los enlaces que tengan también
  asignado el data-confirm con el popup, así controlamos el overlay cuando dan
  al botón de aceptar del modal, no en el click del propio icono
*/
/* global Mn, $, set_overlay, set_overlay_ajax */
const OverlayLink = Mn.View.extend({
  template: noop,
  events: {
    'click': 'click',
    'delete:start': 'aceptanConfirm',
    'delete:done': 'doneConfirm',
    // El confirm de dialogs.js nos lanza este evento
    'confirmado': 'aceptanConfirm',
  },
  click() {
    if (this.$el.data('confirm') || this.$el.data('turboConfirm')) {
      return;
    }
    this.activarOverlay();
  },
  aceptanConfirm() {
    this.activarOverlay();
  },
  doneConfirm() {
    this.overlay.hide();
  },
  activarOverlay() {
    const view = this;
    let $overlayWrapper = $('.main-overlay').first();
    if ($overlayWrapper.length === 0) {
      $overlayWrapper = $('#page-wrapper');
    }

    if (this.$el.data('remote')) {
      this.overlay = set_overlay_ajax($overlayWrapper);
    } else {
      this.overlay = set_overlay($overlayWrapper);
      // Si no es remoto, quitamos el overlay al sustituir la página turbolinks
      $(document).one('page:before-unload', () => {
        view.overlay.hide();
      });
    }

    // Si es un enlace de una carga de un frame, quitamos el overlay al terminar (panel de acciones)
    if (this.$el.data('turbo-frame')) {
      const frame = $(`turbo-frame[id='${this.$el.data('turbo-frame')}']`);

      frame[0].addEventListener('turbo:frame-load', () => {
        if (this.overlay) {
          this.overlay.hide();
          this.overlay = null;
        }
      }, { once: true });
    }
  },
});

export default class extends Controller {
  connect() {
    const options = extend({
      el: this.element,
    }, $(this.element).data());

    this.component = new OverlayLink(options);
    this.component.render();
  }
}
